<template>
  <div 
    class="tooltip-container" 
    @mouseenter="onMouseEnter" 
    @mouseleave="showTooltip = false"
    ref="container"
    data-testid="tooltip-container"
  >
    <slot></slot>
    <div 
      v-if="showTooltip && text" 
      class="tooltip"
      :class="[`tooltip-${position}`, customClass]"
      ref="tooltip"
      data-testid="tooltip-content"
    >
      <div class="tooltip-content" data-testid="tooltip-text">
        {{ text }}
      </div>
      <div class="tooltip-arrow" :class="`arrow-${position}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  methods: {
    onMouseEnter() {
      this.showTooltip = true
      this.$emit('mouseenter')
    }
  }
}
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  z-index: 1000;
  padding: 8px 12px;
  background-color: #2d3748;
  color: white;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  max-width: 250px;
  word-wrap: break-word;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  pointer-events: none;
  opacity: 0;
  animation: fadeIn 0.2s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.tooltip-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Posicionamento */
.tooltip-top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
}

.tooltip-bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
}

.tooltip-left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 8px;
}

.tooltip-right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
}

/* Setas */
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
}

.arrow-top {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #2d3748;
}

.arrow-bottom {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #2d3748;
}

.arrow-left {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #2d3748;
}

.arrow-right {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid #2d3748;
}

/* Classes customizadas */
.tooltip.warning {
  background-color: #f56565;
}

.tooltip.warning .arrow-top {
  border-top-color: #f56565;
}

.tooltip.warning .arrow-bottom {
  border-bottom-color: #f56565;
}

.tooltip.warning .arrow-left {
  border-left-color: #f56565;
}

.tooltip.warning .arrow-right {
  border-right-color: #f56565;
}
</style>
